import React from 'react';
import { Link } from 'react-router-dom';

import { format } from 'date-fns';
import PropTypes from 'prop-types';
import Card from '@/components/common/Card';
import userCircleImage from '@/components/common/icons/user-circle.svg';
import userPermissionImage from '@/components/common/icons/user-permission.svg';
import Spinner from '@/components/common/Spinner';

const ClientUsersComponent = ({ id, intl, status, users }) =>
  !users.length ? (
    <div className="flex justify-center items-center flex-1 p-20">
      <Spinner />
    </div>
  ) : (
    <div className="flex flex-col p-[1.5em_1em] gap-[0.6em]">
      <Card className="fade-in !m-0">
        <h2 className="flex items-center !text-[1.25rem] font-normal leading-normal text-[#5882c1] mb-2 border-b border-[#eee] pb-4">
          <div>
            <Link to={`/clients/${status}/${id}`} className="block">
              <div className="w-[14px] h-[14px] border-l-[3px] border-b-[3px] border-[#c1c1c1] rotate-45 transition-colors hover:border-[#5882c1] cursor-pointer" />
            </Link>
          </div>
          <div className="flex-shrink-0 w-16 flex items-center justify-center">
            <img src={userPermissionImage} alt={intl.formatMessage({ id: 'USERS' })} className="h-6" />
          </div>
          {intl.formatMessage({ id: 'USERS' })}
        </h2>
        <div className="mb-0">
          {users.length &&
            users.map(user => (
              <Link
                to={`/clients/${status}/${id}/users/${user.id}/edit`}
                key={user.id}
                className="block !no-underline color-inherit"
              >
                <div className="flex items-center py-3 hover:bg-gray-50 transition-colors">
                  <div className="flex-shrink-0 w-8 mr-4">
                    <img src={userCircleImage} alt={intl.formatMessage({ id: 'USER' })} className="h-6" />
                  </div>
                  <div className="flex flex-1 items-baseline font-bold text-[0.875em]">
                    <div className="font-bold text-[#000] mr-2">{user.username}</div>
                    {user.email && (
                      <>
                        <div className="text-[#c1c1c1] mr-2">•</div>
                        <div className="text-[#393939] font-semibold truncate" title={user.email}>
                          {user.email}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-[0.8125em] text-[#919191] font-semibold">{`${format(
                    new Date(user.created_at),
                    'dd/MM/yyyy'
                  )}`}</div>
                </div>
              </Link>
            ))}
          {!users.length && (
            <p className="mt-8 text-center text-[#919191]">{intl.formatMessage({ id: 'NO_USERS_CREATED_MESSAGE' })}</p>
          )}
        </div>
      </Card>
    </div>
  );

ClientUsersComponent.propTypes = {
  id: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  users: PropTypes.array,
};

ClientUsersComponent.defaultProps = {
  users: [],
};

export default ClientUsersComponent;
